var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.visible
    ? _c("CampaignModalCon", {
        attrs: { showModal: _vm.visible, newLinkedIn: _vm.newLinkedIn },
        on: {
          saveLinkedIn: _vm.saveLinkedIn,
          "update:showModal": function ($event) {
            _vm.visible = $event
          },
          "update:show-modal": function ($event) {
            _vm.visible = $event
          },
        },
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }